import { render, staticRenderFns } from "./EnrolleeFeedbacks.vue?vue&type=template&id=4f2212b2&"
import script from "./EnrolleeFeedbacks.vue?vue&type=script&lang=js&"
export * from "./EnrolleeFeedbacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports